export enum OrderFulfillment {
  Instant = 'instant',
  Scheduled = 'scheduled',
}
